import { Link, useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useRef, createContext } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { getFirestore, doc, getDocs, onSnapshot, collection } from 'firebase/firestore';
import appFirebase from '../Firebase/Firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faMoneyBill, faWallet, faCalendarAlt, faComments, faSignOutAlt, faSitemap, faUserGroup } from '@fortawesome/free-solid-svg-icons';
import emailjs from 'emailjs-com'; // Importar emailjs
import logoClaro from '../img/logo-blanco.png';
import { Menu, X } from 'lucide-react';
import './NavBarV3.css';
import logo from '../images/Logo.png'; // Asegúrate de importar la imagen
import { useTipoEspacio } from './context/FiltroTipoEspacioContext';

const avatarsMap = {
    userAvatar1: require('../images/1.png'),
    userAvatar2: require('../images/2.png'),
    userAvatar3: require('../images/3.png'),
    userAvatar4: require('../images/4.png'),
    userAvatar5: require('../images/5.png'),
    userAvatar6: require('../images/6.png'),
    userAvatar7: require('../images/7.png'),
    userAvatar8: require('../images/8.png'),
};

const db = getFirestore(appFirebase);
const auth = getAuth();
function NavBarV3() {
    const { setTipoSeleccionado } = useTipoEspacio(); // Usamos el contexto para actualizar el estado
    const [isDarkMode, setIsDarkMode] = useState(false);
    const handleTipoEspacioSelect = (idTipoEspacio) => {
        setTipoSeleccionado(idTipoEspacio); // Actualiza el tipo seleccionado globalmente
    };
    const toggleDarkMode = () => {
        setIsDarkMode(!isDarkMode);
    };
    useEffect(() => {
        const savedTheme = localStorage.getItem('darkMode');
        if (savedTheme) {
            setIsDarkMode(JSON.parse(savedTheme));
        }
    }, []);
    // Guardar el tema cada vez que cambie
    useEffect(() => {
        localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
        if (isDarkMode) {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
    }, [isDarkMode]);
    const [avatarName, setAvatarName] = useState('userAvatar1');
    const [usuario, setUsuario] = useState(null);
    const [userName, setUserName] = useState('');
    const [role, setRole] = useState('');
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const userMenuRef = useRef(null);
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const getAvatarSrc = (avatarName) => avatarsMap[avatarName] || avatarsMap.userAvatar1;
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [tipoEspacios, setTipoEspacios] = useState([]);

    // Detectar el scroll y cambiar el estado de "scrolled"
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true); // Se hace scroll más de 50px
            } else {
                setScrolled(false); // No se hace scroll
            }
        };
        window.addEventListener('scroll', handleScroll);
        // Limpieza del evento al desmontar el componente
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const fetchTipoEspacios = async () => {
            const querySnapshot = await getDocs(collection(db, "tipoespacio"));
            const espacios = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setTipoEspacios(espacios);
        };

        fetchTipoEspacios();
    }, []);
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                setUsuario(user);
                const userDocRef = doc(db, 'usuarios', user.uid);

                // Escuchar cambios en tiempo real usando onSnapshot
                const unsubscribeSnapshot = onSnapshot(userDocRef, (doc) => {
                    if (doc.exists()) {
                        const data = doc.data();
                        setRole(data.role);
                        setUserName(data.name || '');
                        setAvatarName(data.avatar || 'userAvatar1');
                    } else {
                        console.log('No such document!');
                    }
                });
                // Limpieza de la suscripción
                return () => unsubscribeSnapshot();
            } else {
                setUsuario(null);
                setRole('');
                setUserName('');
                setAvatarName('userAvatar1');
            }
        });
        // Limpieza de la suscripción
        return () => unsubscribe();
    }, [auth, db]);
    const toggleUserMenu = () => setUserMenuOpen(!userMenuOpen);
    const [providerForm, setProviderForm] = useState({
        companyName: '',
        ruc: '',
        phone_em: '',
        city: '',
        sector: '',
        parish: '',
        mainStreet: '',
        secondaryStreet: '',
        number_em: '',
        postalCode: '',
        reference: '',
    });
    const [errors, setErrors] = useState({});
    const handleMenuLinkClick = () => {
        setMenuOpen(false);
    };
    const handleButtonClick = () => {
        handleMenuLinkClick();
        setIsModalOpen(true);  // Abre el modal al hacer clic en el botón
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);  // Alterna la visibilidad del modal
    };
    const handleProviderChange = (e) => {
        const { id, value } = e.target;
        setProviderForm({
            ...providerForm,
            [id]: value,
        });
    };
    const handleProviderSubmit = (e) => {
        e.preventDefault(); // Evita el envío automático del formulario
        // Crear una copia del formulario actual
        let newErrors = {};
        // Lista de campos requeridos
        const requiredFields = [
            "companyName",
            "ruc",
            "phone_em",
            "city",
            "sector",
            "parish",
            "mainStreet",
            "secondaryStreet",
            "number_em",
            "postalCode",
            "reference"
        ];

        // Validar que no estén vacíos
        requiredFields.forEach(field => {
            if (!providerForm[field] || providerForm[field].trim() === "") {
                newErrors[field] = "Este campo es obligatorio";
            }
        });

        // Si hay errores, actualizar el estado y no enviar
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Si no hay errores, enviar el formulario
        sendProviderEmail();
    };
    const handleSignOut = () => {
        signOut(auth);
        setUserMenuOpen(false);
    };
    const handleProfileClick = () => {
        setUserMenuOpen(false);
        navigate('/myprofile');
    };
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false); // Modal de confirmación
    const toggleConfirmationModal = () => {
        setIsConfirmationModalOpen(!isConfirmationModalOpen); // Abre o cierra el modal de confirmación
    };
    const sendProviderEmail = (providerDetails) => {
        const message = [
            `Nombre de la empresa: ${providerDetails.companyName}`,
            `RUC: ${providerDetails.ruc}`,
            `Teléfono: ${providerDetails.phone_em}`,
            `Ciudad: ${providerDetails.city}`,
            `Sector: ${providerDetails.sector}`,
            `Parroquia: ${providerDetails.parish}`,
            `Calle principal: ${providerDetails.mainStreet}`,
            `Calle secundaria: ${providerDetails.secondaryStreet}`,
            `Número de teléfono/em: ${providerDetails.number_em}`,
            `Código postal: ${providerDetails.postalCode}`,
            `Referencia: ${providerDetails.reference}`
        ].join('\n');  // Unir todos los elementos del array en un solo string, separado por saltos de línea

        // Enviar el mensaje usando emailjs
        emailjs.send(
            'service_weot8z6', // Reemplaza con tu service ID
            'template_6p6g49j', // Reemplaza con tu template ID
            { message },
            'rQVGkHAuA0UsUrEo9' // Reemplaza con tu user ID de EmailJS  
        )
            .then((response) => {
                console.log('Correo enviado exitosamente', response);

                // Cierra el modal de formulario
                setIsModalOpen(false);

                // Muestra el modal de confirmación
                setIsConfirmationModalOpen(true);
            })
            .catch((error) => {
                console.error('Error al enviar el correo', error);
            });
    };



    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
            <div className="navbar__container">
                {/* Logo */}
                <h1 className="navbar__logo">
                    <Link to="/" onClick={handleMenuLinkClick}>
                        <img
                            src={isDarkMode ? logoClaro : logo}
                            alt="Logo"
                            className="logo-img"
                        />                    </Link>
                </h1>

                {/* Menú de navegación */}
                <ul className={`navbar__menu ${menuOpen ? 'open' : ''}`}>
                    <li>
                        <Link to="https://laofi.work/" onClick={handleMenuLinkClick}>Home</Link>
                    </li>
                    <li>
                        <Link to="https://laofieventos.odoo.com/" target="_blank" rel="noopener noreferrer" onClick={handleMenuLinkClick}>Eventos</Link>
                    </li>
                    <li>
                        <Link to="https://edu-laofi-academy.odoo.com/home-academy" target="_blank" className='community_navbar' onClick={handleMenuLinkClick} >Academia</Link>
                    </li>
                    <li>
                        <Link to="/portal-recargas" onClick={handleMenuLinkClick} >Membresías</Link>
                    </li>
                    <li>
                        <Link to="#" onClick={handleButtonClick} className='frase_navbar'>
                            <strong>Pon tu espacio</strong>
                        </Link>
                    </li>
                    <label className="switch">
                        <input type="checkbox" onChange={toggleDarkMode} checked={isDarkMode} />
                        <span className="slider">
                            <span className="thumb-icon">{isDarkMode ? '🌙' : '🌞'}</span>
                        </span>
                    </label>

                    <li>
                        {!usuario ?
                            (
                                <div className="navbar__account-button">
                                    <Link to="/login" onClick={handleMenuLinkClick} >
                                        Inicia sesión
                                    </Link>
                                </div>
                            ) : (<li ref={userMenuRef}>
                                <div onClick={toggleUserMenu} className="navbar__account-button">
                                    <img src={getAvatarSrc(avatarName)} alt="Avatar" className="navbar__avatar" />
                                    Mi Cuenta
                                </div>

                                {userMenuOpen && (
                                    <ul className="navbar__submenu">
                                        <span className="navbar__username">{userName}</span> <br />
                                        <small className="user-email">{usuario.email}</small>

                                        <li onClick={handleProfileClick}>
                                            <FontAwesomeIcon icon={faUser} /> Perfil
                                        </li>
                                        {role === 'admin' && (
                                            <ul>
                                                <li>
                                                    <Link to="/create-coin-package" onClick={handleMenuLinkClick} >
                                                        <FontAwesomeIcon icon={faMoneyBill} /> Crear Paquete de Monedas
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/verficarCoinsComprados" onClick={handleMenuLinkClick} >
                                                        <FontAwesomeIcon icon={faSitemap} /> Verificar Compras
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Reservas_Admin" onClick={handleMenuLinkClick} >
                                                        <FontAwesomeIcon icon={faCalendarAlt} /> Reservas
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/space" onClick={handleMenuLinkClick} >
                                                        <FontAwesomeIcon icon={faSitemap} /> Pon tu espacio
                                                    </Link>
                                                </li>
                                                
                                                <li>
                                                    <Link to="/users" onClick={handleMenuLinkClick} >
                                                        <FontAwesomeIcon icon={faUserGroup} /> Usuarios
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Busquedas" onClick={handleMenuLinkClick} >
                                                        <FontAwesomeIcon icon={faCalendarAlt} /> Busquedas
                                                    </Link>
                                                </li>
                                            </ul>
                                        )}{role === 'user' && (
                                            <>
                                                <li>
                                                    <Link to="/coin-purchase" onClick={handleMenuLinkClick} >
                                                        <FontAwesomeIcon icon={faWallet} /> Monedero
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/reservasRealizadas" onClick={handleMenuLinkClick} >
                                                        <FontAwesomeIcon icon={faCalendarAlt} /> Mis Reservas
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/coin-purchase" onClick={handleMenuLinkClick} >
                                                        <FontAwesomeIcon icon={faComments} /> Comentarios
                                                    </Link>
                                                </li>
                                            </>
                                        )}{
                                            role === 'prov' && (
                                                <>
                                                    <li>
                                                        <Link to="/coin-purchase" onClick={handleMenuLinkClick} >
                                                            <FontAwesomeIcon icon={faWallet} /> Monedero
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Reservas_Admin" onClick={handleMenuLinkClick} >
                                                            <FontAwesomeIcon icon={faCalendarAlt} /> Reservas
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/space" onClick={handleMenuLinkClick} >
                                                            <FontAwesomeIcon icon={faSitemap} /> Pon tu espacio
                                                        </Link>
                                                    </li>
                                                    <li>
                                                    <Link to="/proveedor/misMarcas" onClick={handleMenuLinkClick} >
                                                        <FontAwesomeIcon icon={faSitemap} /> Administra tu marca
                                                    </Link>
                                                </li>
                                                    <li>
                                                        <Link to="/coin-purchase" onClick={handleMenuLinkClick} >
                                                            <FontAwesomeIcon icon={faComments} /> Comentarios
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/users" onClick={handleMenuLinkClick} >
                                                            <FontAwesomeIcon icon={faUserGroup} /> Clientes
                                                        </Link>
                                                    </li>
                                                </>
                                            )
                                        }
                                        <li onClick={handleSignOut}>
                                            <FontAwesomeIcon icon={faSignOutAlt} /> Cerrar sesión
                                        </li>

                                    </ul>
                                )}
                            </li>
                            )}
                    </li>
                </ul>
                {/* Menú hamburguesa */}
                <div
                    className="navbar__hamburger"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    {menuOpen ? <X size={24} /> : <Menu size={24} />}
                </div>
            </div>
            {isModalOpen && (
                <div className="modal-prov" onClick={toggleModal}> {/* Cierra el modal si se hace clic fuera */}
                    <div className="modal-content-prov" onClick={(e) => e.stopPropagation()}>

                        {/* Encabezado con título y botón de cierre */}
                        <div className="modal-header">
                            <button className="btn-close" onClick={toggleModal}>✖</button>
                            <h4 className='titulo_form_prov'>Información para ser Anfitrión</h4>
                        </div>

                        <div className="modal-body">
                            <form className='form_n_prov' onSubmit={handleProviderSubmit}>
                                {[
                                    { id: "companyName", label: "Razón Social" },
                                    { id: "ruc", label: "RUC" },
                                    { id: "phone_em", label: "Teléfono" },
                                    { id: "city", label: "Ciudad" },
                                    { id: "sector", label: "Sector" },
                                    { id: "parish", label: "Parroquia" },
                                    { id: "mainStreet", label: "Calle Principal" },
                                    { id: "secondaryStreet", label: "Calle Secundaria" },
                                    { id: "number_em", label: "Número" },
                                    { id: "postalCode", label: "Código Postal" }
                                ].map(({ id, label }) => (
                                    <div key={id} className="input-group">
                                        <input id={id} placeholder=" " value={providerForm[id]} onChange={handleProviderChange} required />
                                        <label htmlFor={id}>{label}</label>
                                        {errors[id] && <p className="error-message">{errors[id]}</p>}
                                    </div>
                                ))}
                                <div className="input-group">
                                    <textarea id="reference" placeholder=" " value={providerForm.reference} onChange={handleProviderChange} required />
                                    <label htmlFor="reference">Referencia</label>
                                    {errors.reference && <p className="error-message">{errors.reference}</p>}
                                </div>
                                {/* Botón de guardar */}
                                <div className="button-group">
                                    <button type="submit" className="btn-submit" onClick={sendProviderEmail}>Guardar</button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            )}
            {isConfirmationModalOpen && (
                <div className="modal-prov">
                    <div className="modal-content-prov">
                        <h4 className="titulo_form_prov">¡Gracias por tu información!</h4>
                        <p>Un administrador se contactará contigo pronto.</p>
                        <div className="button-modal-conf-prov">
                            <button type="button" onClick={toggleConfirmationModal} className="btn-close-modal">
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <div className="tipoespacios-menu">
                {tipoEspacios.map((espacio) => (
                    <div
                        key={espacio.IdTipoEspacio} // cuidado: es IdTipoEspacio, no espacio.id
                        className="tipoespacio-item"
                        onClick={() => handleTipoEspacioSelect(espacio.IdTipoEspacio)} // Actualiza el estado global
                    >
                        {/* Imagen del icono */}
                        <img
                            src={espacio.icono}
                            alt={espacio.TipoEspacio}
                            className={`tipoespacio-icono${scrolled ? ' scrolled' : ''}`}
                        />
                        {/* Texto del tipo de espacio */}
                        <span>{espacio.TipoEspacio}</span>
                    </div>
                ))}
            </div>
        </nav>
    );
}

export default NavBarV3;
